// src/components/PageWrapper.jsx
import React from 'react';

export default function PageWrapper({ children, noPadding = false }) {
  return (
    <div
      style={{
        padding: noPadding ? 0 : '24px',
        flex: 1,
        overflowY: 'auto',
        boxSizing: 'border-box',
      }}
    >
      {children}
    </div>
  );
}
